import {
  ColorVariantsDisplayShape,
  ColorVariantsDisplayType,
} from '../../../app-state-types/reducer-state-types/add-to-cart';

export const DEFAULT_COLOR_VARIANTS_WITH_DISPLAY_ALL_VARIANTS = {
  active: false,
  displayShape: ColorVariantsDisplayShape.circle,
  displayType: ColorVariantsDisplayType.grid,
  shouldDisplayAllVariants: false,
};
